module.exports = __webpack_public_path__ + "img/introducePageTwo_show_ten.9841d747.jpg";